"use strict";
exports.__esModule = true;
exports.TEXT_COLORS = void 0;
exports.TEXT_COLORS = {
    primary: 'text-primary-dark',
    danger: '!text-danger-dark',
    warning: 'text-warning-dark',
    secondary: 'text-secondary-dark',
    control: '!text-control-dark',
    tertiary: 'text-tertiary-dark',
    success: 'text-success-dark',
    info: 'text-info-dark',
    inherit: '!text-black',
    slate: 'text-slate-700',
    zinc: 'text-zinc-700',
    neutral: 'text-neutral-700',
    stone: 'text-stone-700',
    red: 'text-red-700',
    orange: 'text-orange-700',
    amber: 'text-amber-700',
    yellow: 'text-yellow-700',
    lime: 'text-lime-700',
    green: 'text-green-700',
    emerald: 'text-emerald-700',
    teal: 'text-teal-700',
    cyan: 'text-cyan-700',
    sky: 'text-sky-700',
    blue: 'text-blue-700',
    indigo: 'text-indigo-700',
    violet: 'text-violet-700',
    purple: 'text-purple-700',
    fuchsia: 'text-fuchsia-700',
    pink: 'text-pink-700',
    rose: 'text-rose-700'
};
//# sourceMappingURL=accordion-details.style.js.map